export const products = {
  alerts: {
    successCreated: 'Your product has been sent for approval.',
    successDeleted: 'Your product has been deleted.',
    successUpdated: 'Your product has been updated.',
  },
  breadcrumb: {
    create: 'Create product',
    edit: 'Edit product',
    overview: 'Products',
  },
  createEdit: {
    blocker: {
      create: 'Are you sure you want to leave this page? Your product has not been saved.',
      edit: 'Are you sure you want to leave this page? Your changes to your product have not been saved.',
    },
    details: {
      title: 'Product details',
    },
    info: {
      description: 'Enter your product information here',
      title: 'Product information',
    },
    submit: {
      create: 'Create product',
      edit: 'Edit product',
      save: 'Save',
    },
    title: {
      create: 'New product',
      edit: 'Edit product',
    },
  },
  fields: {
    activityType: {
      label: 'Type of service',
      placeholder: 'Type of service',
      tooltip:
        'Choose which type of service applies. <a href="https://knowledge.creativeshelter.be/wanneer-factureer-je-welke-soort-prestatie" target="_blank">Not sure? Check here when to invoice which type of service.</a>',
    },
    categories: {
      label: 'Categories',
      placeholder: 'Add a category, such as: editing, post-production, translation, copy editing …',
    },
    name: {
      inLanguage: {
        en: 'Product name English',
        fr: 'Product name French',
        nl: 'Product name Dutch',
      },
      label: 'Product name',
      placeholder: 'Product name',
    },
    price: {
      label: 'Price (excl. VAT)',
      tooltip:
        'Do you often use the same price for your product? Fill it in now and save yourself some work. You can still change it when drawing up your invoice.',
    },
    unit: {
      label: 'Unit',
      placeholder: 'Choose a unit',
      tooltip:
        'Do you often use the same unit for your product? Fill it in now and save yourself some work. You can still change it when drawing up your invoice.',
    },
  },
  header: {
    actionBlock: {
      button: 'Create product',
    },
    title: 'Products',
  },
  modal: {
    add_one: 'Add {{count}} product',
    add_other: 'Add {{count}} products',
    add_zero: 'Add product(s)',
    createNew: 'Create new product',
    title: 'Add product(s)',
  },
  overview: {
    columns: {
      creativeWork: 'Type',
      name: 'Product name',
      price: 'Price',
      productCategories: 'Categories',
      status: {
        options: {
          Approved: 'Approved',
          InReview: 'Pending approval',
          Rejected: 'Rejected',
        },
        title: 'Status',
      },
    },
    deleteModal: {
      description: 'Are you sure you want to delete this product?',
      title: 'Delete product',
    },
    infoCard: {
      instantInvoices: {
        description: 'An invoice with only approved products? It can go straight to your client, without us checking it again.',
        href: 'https://knowledge.creativeshelter.be/wat-is-instant-factureren',
        label: 'More info',
        title: 'Instant invoicing',
      },
      products: {
        description: 'An invoice line you create once and can then reuse every time on an invoice or quotation.',
        href: 'https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze',
        label: 'More info',
        title: 'Products',
      },
      title: 'About products',
    },
  },
};
